import { render } from "./boundday.vue?vue&type=template&id=4a82f3e8"
import script from "./boundday.vue?vue&type=script&lang=js"
export * from "./boundday.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__